import React from 'react'

const Expenses = () => {
    return (
        <div className="p-4">Expenses Content</div>
    )
}

export default Expenses
